export default function uppercase(input) {
    return input.toUpperCase();
}